class Row {
  constructor($pool, $plugins, rowName) {
    this.$pool = $pool
    this.$plugins = $plugins
    this.name = rowName
    this.cells = []
  }

  connect(row) {
    this.node = row.node
    this.cells = row.cells

    return this
  }

  changeMode(mode, newMode, data) {
    this.$plugins.emit("Row:changeMode", {
      Controller: this,
      ...data,
      mode,
      newMode,
    })
  }
}

export default Row
